import React from 'react';
import ExclamationMark from '@monofront/design-system/visuals/Icons/Old/ExclamationMark';
import Link from 'next/link';
import SuccessFilled from '@monofront/design-system/visuals/Icons/SuccessFilled';
import { IconSizes } from '@monofront/design-system/visuals/Icons/type';
import { colors } from '@monofront/theme';
import getConfig from 'next/config';
import New from '@monofront/design-system/visuals/Pictograms/New';
import { useRelativeDateTime } from '@hooks/useRelativeDateTime';
import { CustomPageTypes, TABLE_HEADER } from '@constants/customPage';
import { IPageContent } from './type';

const {
  publicRuntimeConfig: { appBaseUrl },
} = getConfig();

interface ITableRowProps {
  pageContent: IPageContent;
}

const TableRow = ({ pageContent }: ITableRowProps) => {
  const lastPublicationDate = useRelativeDateTime(
    pageContent.last_publication_date,
  );

  const generateRedirectionPage = (pageType: string, uid: string) => {
    switch (pageType) {
      case CustomPageTypes.PAGE:
        return `${appBaseUrl}/pages/${uid}`;
      case CustomPageTypes.LANDINGPAGE:
        return `${appBaseUrl}/lp/${uid}`;
      default:
        return `/`;
    }
  };

  const checkSeoFilling = (seoTitle: string, seoDescription: string) => {
    if (seoTitle && seoDescription)
      return <SuccessFilled size={IconSizes.sm} color={colors.quatertiary1} />;
    if (seoTitle || seoDescription)
      return <ExclamationMark color={colors.primary1} />;

    return <ExclamationMark />;
  };

  const isNewPage = () => {
    const date = new Date(pageContent.first_publication_date);
    const currentDate = new Date();
    const differenceInMs: number = currentDate.getTime() - date.getTime();
    const differenceInDays: number = differenceInMs / (1000 * 60 * 60 * 24);

    return Math.floor(differenceInDays) <= 3;
  };

  return (
    <tr
      key={pageContent.uid}
      className="tw-border tw-border-b-2 tw-border-red-400 tw-text-center even:tw-bg-yellow-100"
    >
      <td className="tw-p-2">
        <Link
          href={generateRedirectionPage(pageContent.type, pageContent.uid)}
          legacyBehavior
        >
          <a className="tw-lf-link-md ">{pageContent.uid}</a>
        </Link>
        {Boolean(isNewPage()) && <New />}
      </td>
      <td className="tw-p-2">{pageContent.id}</td>
      <td className="tw-p-2">
        <Link
          target="_blank"
          href={`https://la-fourche.prismic.io/documents~w=${pageContent.uid}&b=working&c=published&l=fr-fr/${pageContent.id}/`}
          legacyBehavior
        >
          <a className="tw-lf-link-md">{TABLE_HEADER.prismicLink}</a>
        </Link>
      </td>
      {pageContent.type === 'landingpage' && (
        <td className="tw-p-2">
          {checkSeoFilling(
            pageContent.data?.seoDescription ?? '',
            pageContent.data?.seoTitle ?? '',
          ) || ' '}
        </td>
      )}
      <td className="tw-p-2">
        <p>{lastPublicationDate}</p>
      </td>
    </tr>
  );
};

export default TableRow;
